<div class="sub-header-container">
    <h2 *ngIf="title" class="subtitle">{{ title | translate }}</h2>
    <div class="buttons-container floating-buttons">
        <ng-content></ng-content>
    </div>
</div>
